(function () {
    angular.module('emarket.main.profile').controller('ProfileDetailController', function () {

    });
}());
